import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'normalize.css';
import '@/styles/element-variables.scss';
import '@/styles/custom-variables.scss';
import '@/styles/cesium-navigation.css';
import { initMqtt } from '@/utils/mqtt';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn, // 全局配置中文
});

// 全局注册 SvgIcon 组件（轻量级渲染包装，不加载任何具体图标）
import SvgIcon from '@/components/SvgIcon/index.vue';
app.component('SvgIcon', SvgIcon);

// const mqttUrl = process.env.VUE_APP_MQTT_URL;
// if (mqttUrl) {
//   initMqtt(
//     {
//       url: mqttUrl,
//       username: process.env.VUE_APP_MQTT_USERNAME,
//       password: process.env.VUE_APP_MQTT_PASSWORD,
//       clientId: process.env.VUE_APP_MQTT_CLIENT_ID,
//     },
//     (client) => {
//       // 初始化完成后可直接使用 mqtt.js 原生 client 能力
//       console.log('MQTT client ready', client.connected);
//     }
//   );
// } else {
//   console.warn('VUE_APP_MQTT_URL 未配置，已跳过 MQTT 初始化');
// }

app.mount('#app');
